/* eslint-disable no-fallthrough */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Form, Col, Row, Spinner, SplitButton, ButtonGroup, DropdownButton, Accordion, Tooltip } from 'react-bootstrap';


import { ArticleService } from '../../../../services/ArticleService';
import { EditionService } from '../../../../services/EditionService';

import DynamicTable from '../../../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../../../components/pagination/Pagination';
import SideDetails from '../../../../components/side-details/SideDetails';
import ClientDetails from '../../../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../../../components/families/Families';
import { PreferenceService } from '../../../../services/PreferenceService';
import { ClientService } from '../../../../services/ClientService';
import ConfirmDialog from '../../../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../../../helper/Helper'
import TagsFilter from "../../../../components/tags-filter/TagsFilter";
import { AnalyseService } from '../../../../services/AnalyseService';
import ReleveClientDetails from './ReleveClientDetails';
import PeriodeFilter from "../../../../components/periode-filter/PeriodeFilter";
import SendMailDialog from "../../../../components/send-mail-dialog/SendMailDialog";



const ReleveClientTpl = ({ currentEdition }) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

    let clientsParams = useRef({
        'start': 0,
        'limit': 20,
        'search': null,
        'filters': null,
        'sort': "code",
        'order': "asc",
        'fields': null
    });

    let openTab = useRef();

    const [globalError, setGlobalError] = useState()
    const [clients, setClients] = useState()
    const [isGetClientsLoading, setIsGetClientsLoading] = useState()
    const [isPDFLoading, setIsPDFLoading] = useState()
    const [sideWidth, setSideWidth] = useState()
    const [sendMailDialog, setSendMailDialog] = useState({})
    const [tableHeaders, setTableHeaders] = useState([
        {
            "label": "Identifiant",
            "dataTarget": "_id",
            "type": "string",
            "hidden": true,
            "position": 0,
            "align": "left",
            "colSize": 2,
            "filters": false,
            "sortable": false,
            "readOnly": false
        },
        {
            "label": "Code",
            "dataTarget": "code",
            "type": "string",
            "hidden": false,
            "position": 1,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Nom",
            "dataTarget": "nom",
            "type": "string",
            "hidden": false,
            "position": 2,
            "align": "left",
            "colSize": 6,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Type",
            "dataTarget": "type",
            "type": "string",
            "hidden": false,
            "position": 3,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Remise",
            "dataTarget": "taux_remise",
            "type": "percentage",
            "hidden": true,
            "position": 4,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Tags",
            "dataTarget": "tags",
            "type": "tags",
            "hidden": false,
            "position": 5,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Interdir",
            "dataTarget": "interdir",
            "type": "string",
            "hidden": true,
            "position": 6,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Observation",
            "dataTarget": "observation",
            "type": "markdown",
            "hidden": false,
            "position": 7,
            "align": "left",
            "colSize": 6,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Bloquer",
            "dataTarget": "bloquer",
            "type": "bloquer",
            "hidden": false,
            "position": 8,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Profession",
            "dataTarget": "profession",
            "type": "string",
            "hidden": true,
            "position": 9,
            "align": "left",
            "colSize": 3,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "adresses",
            "dataTarget": "adresses",
            "type": "adresses",
            "hidden": false,
            "position": 10,
            "align": "left",
            "colSize": 2,
            "filters": false,
            "sortable": false,
            "readOnly": false
        },
        {
            "label": "interlocuteurs",
            "dataTarget": "interlocuteurs",
            "type": "interlocuteurs",
            "hidden": false,
            "position": 11,
            "align": "left",
            "colSize": 2,
            "filters": false,
            "sortable": false,
            "readOnly": false
        },
        {
            "label": "Exonerer T.G.C",
            "dataTarget": "exonerer_taxes",
            "type": "booleanTrueOnly",
            "hidden": true,
            "position": 12,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Debit maximum",
            "dataTarget": "debit_max",
            "type": "number",
            "hidden": true,
            "position": 13,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Conditions paiement",
            "dataTarget": "condition_paiement",
            "type": "string",
            "hidden": true,
            "position": 14,
            "align": "left",
            "colSize": 4,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "R.I.B",
            "dataTarget": "rib",
            "type": "string",
            "hidden": true,
            "position": 15,
            "align": "left",
            "colSize": 3,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "I.B.A.N",
            "dataTarget": "iban",
            "type": "string",
            "hidden": true,
            "position": 16,
            "align": "left",
            "colSize": 3,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Titulaire",
            "dataTarget": "titulaire",
            "type": "string",
            "hidden": true,
            "position": 17,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "R.I.D.E.T",
            "dataTarget": "ridet",
            "type": "string",
            "hidden": true,
            "position": 18,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "Code A.P.E",
            "dataTarget": "code_ape",
            "type": "string",
            "hidden": true,
            "position": 19,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "G.P.S",
            "dataTarget": "gps",
            "type": "gps",
            "hidden": true,
            "position": 20,
            "align": "left",
            "colSize": 2,
            "filters": false,
            "sortable": false,
            "readOnly": false
        },
        {
            "label": "Exonorer EcoParticipation",
            "dataTarget": "exonerer_eco_participation",
            "type": "booleanTrueOnly",
            "hidden": true,
            "position": 21,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "echeance_comptable.jour_du_mois",
            "dataTarget": "echeance_comptable.jour_du_mois",
            "type": "number",
            "hidden": true,
            "position": 22,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "echeance_comptable.fin_mois",
            "dataTarget": "echeance_comptable.fin_mois",
            "type": "boolean",
            "hidden": true,
            "position": 23,
            "align": "left",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        },
        {
            "label": "echeance_comptable.nombre_jours",
            "dataTarget": "echeance_comptable.nombre_jours",
            "type": "number",
            "hidden": true,
            "position": 24,
            "align": "right",
            "colSize": 2,
            "filters": true,
            "sortable": true,
            "readOnly": false
        }
    ])
    const [checkedElementIdList, setCheckedElementIdList] = useState([])
    const [currentPagination, setCurrentPagination] = useState(1)
    const [isTableFilterVisible, setIsTableFilterVisible] = useState(true)
    const [currentClient, setCurrentClient] = useState()
    const [isReleveClientEditionLoading, setIsReleveClientEditionLoading] = useState(false)
    const [includeLettrees, setIncludeLettrees] = useState(false)
    const [includeSoldes, setIncludeSoldes] = useState(false)
    const [dateDebutFin, setDateDebutFin] = useState()

    const [tableRowElementActions] = useState([])
    const [clientElementActions] = useState([])

    let searchRef = useRef(null);

    useEffect(() => {
        if (globalContextLoaded) {
            clientsParams.current['fields'] = Object.keys(preferences?.clients.tableHeaders).join(',')
            getClients()
        }
    }, [globalContextLoaded]);

    function getClients() {
        setCheckedElementIdList([])
        if (granted(grants, "clients.consult")) {
            setIsGetClientsLoading(true)
            ClientService.getClients(folderDetails?.dossier?._id, clientsParams.current).then(res => {
                setClients(res.data.data)
                setIsGetClientsLoading(false)
            }).catch(error => {
                setIsGetClientsLoading(false)
                setGlobalError(error)
            });
        }
    }

    function changeCurrentClient(client) {
        setCurrentClient(client)
    }

    function changeTableHeaders(e) {
        setTableHeaders(e)
    }

    function changePagination(p) {
        setCurrentPagination(p)
        clientsParams.current['start'] = (clientsParams.current.limit * p) - clientsParams.current.limit
        getClients()
    }

    function changeLimit(l) {
        clientsParams.current['limit'] = l
        changePagination(1)
    }

    let searchTimeOut;
    function changeSearchValue(value) {
        window.clearTimeout(searchTimeOut);
        searchTimeOut = window.setTimeout(function () {
            setCurrentPagination(1)
            clientsParams.current['start'] = 0
            clientsParams.current['search'] = value ? value : ""
            searchRef.current.value = value ? value : ""
            getClients()
        }, 1000);
    }

    let filtersTimeOut;
    function changeFilters(f) {
        window.clearTimeout(filtersTimeOut);
        filtersTimeOut = window.setTimeout(function () {
            setCurrentPagination(1)
            clientsParams.current['start'] = 0
            clientsParams.current['filters'] = f
            getClients()
        }, 1000);
    }

    function changeTagIdList(tagIdList) {
        let filtersCopy = { ...clientsParams?.current['filters'] }
        if (tagIdList.length > 0) {

            let tagArray = []
            tagIdList.map(tagId => {
                tagArray.push(tagId)
            })

            if (!filtersCopy[`filter[tags._id]`]) {
                filtersCopy[`filter[tags._id]`] = []
            }

            filtersCopy[`filter[tags._id]`] = [
                {
                    "operation": "equal_to",
                    "operator": "=",
                    "value": tagArray.toString()
                }
            ]
            changeFilters(filtersCopy)
        } else {
            if (filtersCopy && filtersCopy[`filter[tags._id]`]) {
                delete filtersCopy[`filter[tags._id]`]
                changeFilters(filtersCopy)
            }
        }
    }

    function clearFilters() {
        setCurrentPagination(1)
        clientsParams.current['start'] = 0
        clientsParams.current['filters'] = null
        getClients()
    }

    function changeSortOrder(s, o) {
        clientsParams.current['sort'] = s
        clientsParams.current['order'] = o
        getClients()
    }

    function closeSide() {
        setCurrentClient()
    }

    function getEditions(format, checkedElements) {

        setIsReleveClientEditionLoading(true)

        let params = {
            "include_lettrees": includeLettrees,
            "include_soldes": includeSoldes,
            "client_filter": {},
            "filter": {}
        }

        if (dateDebutFin) {
            params["filter"]["date"] = `${dateDebutFin.dateDebut ? `>=${dateDebutFin.dateDebut}` : ""}${dateDebutFin.dateFin ? `&<=${dateDebutFin.dateFin}` : ""}`
        }

        if (clientsParams.current.search) {
            params["client_filter"]["search"] = clientsParams.current.search
        }

        // formatte les filtres dna le format attendu par la requete
        if (clientsParams.current.filters) {
            params["client_filter"]["filter"] = {}
            Object.keys(clientsParams.current.filters).map((key, value) => {
                var filterName = key.substring(
                    key.indexOf("[") + 1,
                    key.lastIndexOf("]")
                );
                let filterValue = ""
                clientsParams.current.filters[key].map((filter, i) => {
                    filterValue = filterValue + filter.operator + filter.value + (i < clientsParams.current.filters[key].length - 1 ? "," : "")
                })
                params["client_filter"]["filter"][filterName] = filterValue
            })
        }

        if (checkedElements) {
            params["clients"] = checkedElementIdList
        }

        EditionService.getEditions(folderDetails?.dossier?._id, params, "analyses/relevesclients", format).then(res => {

            setIsReleveClientEditionLoading(false)

            if (res.status == 204 || !res?.data) {
                setGlobalError({ statusText: `Aucun résultat n'a été trouvé (${res.statusText})` })
            } else {
                setGlobalError()
                getFile(res, format)
            }
        }).catch(error => {
            setIsReleveClientEditionLoading(false)
            setGlobalError(error)
        });
    }

    function changeDate(dateObject) {

        setDateDebutFin(dateObject)


        // setDateDebutFin(`${dateObject.dateDebut ? `>=${dateObject.dateDebut}` : ""}${dateObject.dateFin ? `&<=${dateObject.dateFin}` : ""}`)

        /* {
            "dateDebut": "2026-04-01",
            "dateFin": "2026-06-30"
        } */


        /* delete releveParams.current?.filters?.['filter[date]']
        if (dateObject.dateDebut) {
            setFilterDateDebut(dateObject.dateDebut)
        }
        if (dateObject.dateFin) {
            setFilterDateFin(dateObject.dateFin)
        }
        changePagination(1)
        getReleve() */
    }

    function sendEmail(facture, source) {

        // Si envoie mail à partir d'une facture unique'
        /* if (facture) {
            let params = {
                filter: {
                    _id: "=" + facture._id
                }
            }

            setSendMailDialog({
                "clientIdList": [facture.client_id],
                "folderId": folderDetails?.dossier?._id,
                "editionUrl": "factures",
                "params": params,
                "totalElements": 1,
                "show": true
            })
            return
        } */

        // Si envoie mail à partir des filtres
        if (source == "filters") {

            let params = {
                "include_lettrees": includeLettrees,
                "include_soldes": includeSoldes,
                "client_filter": {},
                "filter": {}
            }

            if (dateDebutFin) {
                params["filter"]["date"] = `${dateDebutFin.dateDebut ? `>=${dateDebutFin.dateDebut}` : ""}${dateDebutFin.dateFin ? `&<=${dateDebutFin.dateFin}` : ""}`
            }

            if (clientsParams.current.search) {
                params["client_filter"]["search"] = clientsParams.current.search
            }

            // formatte les filtres dna le format attendu par la requete
            if (clientsParams.current.filters) {
                params["client_filter"]["filter"] = {}
                Object.keys(clientsParams.current.filters).map((key, value) => {
                    var filterName = key.substring(
                        key.indexOf("[") + 1,
                        key.lastIndexOf("]")
                    );
                    let filterValue = ""
                    clientsParams.current.filters[key].map((filter, i) => {
                        filterValue = filterValue + filter.operator + filter.value + (i < clientsParams.current.filters[key].length - 1 ? "," : "")
                    })
                    params["client_filter"]["filter"][filterName] = filterValue
                })
            }

            if (clients?.total == 1) {
                params['clients'] = [clients.clients[0]._id]
            }

            setSendMailDialog({
                "clientIdList": clients?.total == 1 ? [clients.clients[0]._id] : null,
                "folderId": folderDetails?.dossier?._id,
                "editionUrl": "analyses/relevesclients",
                "params": params,
                "totalElements": clients?.total,
                "show": true
            })
            return
        }

        // Si envoie mail à partir des éléments sélectionnés
        if (source == "checked") {
            let params = {
                "include_lettrees": includeLettrees,
                "include_soldes": includeSoldes,
                clients: checkedElementIdList
            }

            setSendMailDialog({
                "clientIdList": [checkedElementIdList],
                "folderId": folderDetails?.dossier?._id,
                "editionUrl": "analyses/relevesclients",
                "params": params,
                "totalElements": checkedElementIdList.length,
                "show": true
            })
            return
        }

    }


    return (
        <>
            <ErrorManager error={globalError} fixed="true" />
            <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />
            <Row className="mb-2">
                <Col className="d-flex align-items-center">
                    <h4>{currentEdition?.label}</h4>
                    <div className="ms-auto p-2 bg-gray-100 me-2 rounded d-flex align-items-end">
                        <PeriodeFilter onDateChange={(dateObject) => changeDate(dateObject)} />
                        <span className="ms-3 d-inline-flex">
                            <Form.Check
                                className="m-0 me-2"
                                type="checkbox"
                                name="include_lettrees"
                                onClick={() => setIncludeLettrees(!includeLettrees)}
                                label="Inclure lettrées"
                            />
                        </span>
                        <span className="ms-2 d-inline-flex">
                            <Form.Check
                                className="m-0 me-2"
                                type="checkbox"
                                name="include_soldes"
                                onClick={() => setIncludeSoldes(!includeSoldes)}
                                label="Inclure soldés"
                            />
                        </span>
                        {checkedElementIdList?.length > 0 &&
                            <ButtonGroup>
                                <Button disabled={isReleveClientEditionLoading} className="ms-3 d-flex align-items-center text-start" variant="dark" onClick={() => getEditions("pdf", true)}>
                                    {isReleveClientEditionLoading &&
                                        <Spinner animation="border" size="sm" className="me-2" />
                                    }
                                    <div className="d-flex flex-column ">
                                        <span>{checkedElementIdList.length} Client(s) sélectionné(s)</span>
                                        <span className="text-gray-300">Télécharger les relevés (PDF)</span>
                                    </div>
                                </Button>
                                <DropdownButton disabled={isReleveClientEditionLoading} as={ButtonGroup} variant="dark">
                                    <Dropdown.Item onClick={() => getEditions("xls", true)}>Télécharger en XLS</Dropdown.Item>
                                    <Dropdown.Item onClick={() => sendEmail(null, "checked")}>Envoyer par mail</Dropdown.Item>
                                </DropdownButton>
                            </ButtonGroup>
                        }
                        <ButtonGroup>
                            <Button disabled={!clients?.total || isReleveClientEditionLoading} className="ms-3 d-flex align-items-center text-start" onClick={() => getEditions("pdf")}>
                                {isReleveClientEditionLoading &&
                                    <Spinner animation="border" size="sm" className="me-2" />
                                }
                                <div className="d-flex flex-column ">
                                    <span>{clients?.total ? clients?.total : 0} Résultat(s) client(s)</span>
                                    <span className="text-primary-200">Télécharger les relevés (PDF)</span>
                                </div>

                            </Button>
                            <DropdownButton disabled={!clients?.total || isReleveClientEditionLoading} as={ButtonGroup}>
                                <Dropdown.Item onClick={() => getEditions("xls")}>Télécharger en XLS</Dropdown.Item>
                                <Dropdown.Item onClick={() => sendEmail(null, "filters")}>Envoyer par mail</Dropdown.Item>
                            </DropdownButton>
                        </ButtonGroup>
                    </div>
                </Col>
            </Row>
            <Row className="mb-4 gx-2">
                {granted(grants, "clients.consult") ?
                    <>
                        <Col sm="12" md="3" className="d-flex align-items-center mb-2 mb-md-0">
                            <InputGroup className="w-100">
                                <i className="material-icons input-icon text-gray-400">search</i>
                                <FormControl
                                    className="input-icon-space rounded-start"
                                    placeholder="Recherche globale"
                                    type="text"
                                    onChange={e => changeSearchValue(e.target.value)}
                                    ref={searchRef}
                                />
                                {clientsParams.current['search'] &&
                                    <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                                        <i className="material-icons i-lg">clear</i>
                                    </Button>
                                }
                            </InputGroup>
                        </Col>
                        <Col sm="12" md="auto" className="d-flex align-items-center mb-2 mb-md-0">
                            <InputGroup className="me-2 w-auto">
                                <TagsFilter btnClassName={clientsParams.current.filters ? "rounded-end-0" : ""} btnTitle="Filtrer par tags" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={clientsParams?.current['filters']} />
                                {clientsParams.current.filters &&
                                    <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                                        Suppr. les filtres
                                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                                    </Button>
                                }
                            </InputGroup>
                            <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                        </Col>
                    </>
                    :
                    <Col>
                        <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
                    </Col>
                }
            </Row>
            {granted(grants, "clients.consult") &&
                <Row className="mt-3">
                    <Col xs="12">
                        <div className="bg-white rounded border">
                            <DynamicTable
                                isDataLoading={isGetClientsLoading}
                                elementActions={tableRowElementActions}
                                setElementAction={(a, e) => eval(a)(e)}
                                sideWidth={sideWidth}
                                tableHeaders={tableHeaders}
                                tableDataList={clients?.clients}
                                currentElement={currentClient}
                                changeCurrentElement={e => changeCurrentClient(e)}
                                checkedElementIdList={checkedElementIdList}
                                setCheckedElementIdList={e => setCheckedElementIdList(e)}
                                changeFilters={f => changeFilters(f)}
                                isTableFilterVisible={isTableFilterVisible}
                                changeSortOrder={(s, o) => changeSortOrder(s, o)}
                                params={clientsParams.current}
                            />
                            <Pagination className="m-3" itemsLength={clients?.total} elementsPerPage={clientsParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit changeLimit={l => changeLimit(l)} />
                        </div>
                    </Col>
                </Row>
            }

            {currentClient &&
                <SideDetails
                    editMode={false}
                    currentElement={{ id: currentClient._id, label: currentClient.code, title: currentClient.nom }}
                    changeCurrentElement={e => changeCurrentClient(e)}
                    setSideClose={closeSide}
                    setSideCancel={closeSide}
                    setSideWidth={e => setSideWidth(e)}
                    detailsComponent={<ReleveClientDetails currentClient={currentClient} dateDebutFin={dateDebutFin} />}
                />
            }
        </>
    )
}

{/* <ClientDetails openTab={openTab.current} folderId={folderDetails?.dossier?._id} clientId={currentClient._id} elementActions={clientElementActions} setElementAction={(a, e) => eval(a)(e)} /> */ }

export default ReleveClientTpl;